import type { CSSProperties } from "react";

// The one vault, reached through many "doors". Shared by the HUD and every
// drill-in page (via Page) so the tagline never drifts between them again.
// Life OS Web (this HUD) is the door you're standing in, so it renders as active.
const DOORS: { icon: string; label: string; here?: boolean }[] = [
  { icon: "fa-solid fa-terminal", label: "Coding Agents" },
  { icon: "fa-solid fa-comment-dots", label: "AI Assistants" },
  { icon: "fa-solid fa-gauge-high", label: "Life OS Web", here: true },
];
const doorChip: CSSProperties = { display: "inline-flex", alignItems: "center", gap: 7, fontSize: 11.5, fontWeight: 700, padding: "6px 12px", borderRadius: 999, border: "1px solid var(--line)", background: "var(--card2)", color: "var(--mut)" };
const doorHere: CSSProperties = { ...doorChip, color: "var(--accent-ink)", background: "var(--raise)", border: "1px solid var(--line2)" };

export default function Footer() {
  return (
    // Lives inside each screen's --shell-max content column (Page / Hud), as the last
    // child after a flex:1 content area that pushes it to the bottom. The marginTop
    // (on top of the column's own 18px gap) keeps clear space above the divider so
    // it never crowds the last row; the border spans the column, aligned with the
    // cards. Content + footer share one div, so they can't overlap by construction.
    <footer style={{ marginTop: 26, paddingTop: 26, borderTop: "1px solid var(--line)", display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
      <div style={{ display: "inline-flex", alignItems: "center", gap: 9, fontSize: 12.5, fontWeight: 700, color: "var(--sub)", letterSpacing: "-0.01em" }}>
        <i className="fa-solid fa-brain" style={{ fontSize: 12, lineHeight: 1, color: "var(--sub)" }} />
        One Brain, Many Doors
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 8 }}>
        {DOORS.map((dr) => (
          <span key={dr.label} style={dr.here ? doorHere : doorChip}>
            <i className={dr.icon} style={{ fontSize: 10.5, lineHeight: 1 }} />
            {dr.label}
          </span>
        ))}
      </div>
    </footer>
  );
}
